import { createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4776574a")

_pushScopeId("data-v-4776574a")
const _hoisted_1 = { class: "form-time-input" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-clock" }, null, -1)
const _hoisted_4 = { class: "time--item" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "hh--content mr-2" }
const _hoisted_7 = { class: "ss--content" }
const _hoisted_8 = {
  key: 0,
  class: "text-error-detail"
}
const _hoisted_9 = { class: "text-error" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        style: _ctx.style,
        class: ["block shadow-sm md:text-base lg:text-base sm:text-sm sm:h-8 md:h-12 lg:h-12 left-auto flex relative input-wrapper cursor-pointer items-center", _ctx.disabled ? 'disable' : ''],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowTimeSelected = true))
      }, [
        _createVNode("input", {
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled,
          class: "w-full outline-none",
          type: "text",
          value: _ctx.value,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeInput($event)))
        }, null, 40, ["placeholder", "disabled", "value"]),
        _hoisted_3
      ], 6),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(24).keys(), (item) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: ["hh--item", _ctx.hour === item ? 'selected' : ''],
              onClick: ($event: any) => (_ctx.chooseHour(item))
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(60).keys(), (item) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: ["ss--item", _ctx.minutes === item ? 'selected' : ''],
              onClick: ($event: any) => (_ctx.chooseMinutes(item))
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isShowTimeSelected]
    ]),
    ((_ctx.validated || _ctx.firstEnter) && (_ctx.errorMessage || _ctx.errorServer))
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("span", null, _toDisplayString(_ctx.errorMessage || _ctx.errorServer), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "fixed top-0 left-0 w-screen h-screen z-50",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowTimeSelected = false))
    }, null, 512), [
      [_vShow, _ctx.isShowTimeSelected]
    ])
  ]))
})